module.exports = __webpack_public_path__ + "img/414-bc1d4a.png";